import AllFilters from 'filters/all-filters';
import Analysis from 'analyse/analysis';
import {setUpgradeSkillsInclusion} from 'sales/upgrade';

window.analyse = function () {
    function pageBodyLoad() {
        checkUserStatus();
        setScrollEvent();
        setResizeEvent();
        setIntersectionObserver();
    }

    function setScrollEvent() {
        document.addEventListener("scroll", function () {
            configureSectionNavigation();
        }, false);
    }

    function setResizeEvent() {
        window.addEventListener("resize", function () {
            configureSectionNavigation();
        }, false);
    }

    function configureSectionNavigation() {
        setActiveSection();
    }

    // Check when section select element is pinned, display additional view list control
    function setIntersectionObserver() {
        const el = document.querySelector("#sectionsListHolder");
        const styles = getComputedStyle(el);
        // Adjust margin of interaction to account for page header and filters bar
        const topMarginAdjustment = parseFloat(styles.top) + 5;
        const observer = new IntersectionObserver(
        ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1), {
            threshold: [1],
            rootMargin: `-${topMarginAdjustment}px 0px 0px 0px`
        });
        observer.observe(el);
    }

    function setActiveSection() {
        let sections, activeSection, activeSectionElement;
        sections = document.querySelectorAll(".subsection[data-section]");
        if (sections) {
            // Filter to discount elements beyond the top third of the screen, sort by closest position to top of screen. Take the top results section
            activeSection = Array.from(sections).filter(el => el.getBoundingClientRect().top < window.innerHeight * 0.3).sort((a, b) => { if (Math.abs(a.getBoundingClientRect().top) > Math.abs(b.getBoundingClientRect().top)) { return 1; } else if (Math.abs(a.getBoundingClientRect().top) < Math.abs(b.getBoundingClientRect().top)) { return -1; } else { return 0; }}).map(el => el.dataset.section)[0];
            if (activeSectionElement = document.querySelector(".sectionActive")) {
                activeSectionElement.classList.remove("sectionActive"); // Remove class from existing
            }
            if (activeSection) {
                document.querySelector(`.sectionElement[data-section='${activeSection}']`).classList.add("sectionActive");
            } else if (document.getElementById("sectionsList").firstChild) {
                document.getElementById("sectionsList").firstChild.classList.add("sectionActive");
            }
        }
    }

    function positionSectionNavigation() {
        let sectionHolder, listSummaryHolderBounds, pageHeaderBounds, filtersHeaderBounds;
        sectionHolder = document.getElementById("sectionHolder");
        listSummaryHolderBounds = document.getElementById("listSummaryHolder").getBoundingClientRect();
        pageHeaderBounds = document.getElementById("pageHeader").getBoundingClientRect();
        filtersHeaderBounds = document.getElementById("filtersHeader").getBoundingClientRect();

        if (filtersHeaderBounds.bottom > 0) {
            sectionHolder.classList.remove("fixed");
            sectionHolder.classList.add("absolute");
        } else {
            sectionHolder.classList.remove("absolute");
            sectionHolder.classList.add("fixed");
            sectionHolder.style.left = `${listSummaryHolderBounds.left - Number(getComputedStyle(sectionHolder).width.replace("px", ""))}px`;
            sectionHolder.style.top = `${(filtersHeaderBounds.bottom > 0) ? filtersHeaderBounds.bottom : pageHeaderBounds.bottom}px`
        }
    }

    function checkUserStatus() {
        let method, url, input;

        method = "GET";
        url = "../api/user/user_actions.php?action=check_user";

        const checkUserStatusSuccess = function (response) {
            const responseParsed = JSON.parse(response);
            // Valid user
            if (responseParsed.logged_in == true) {
                coreFunctions.userguidingSetup(responseParsed);
                filters.getAllFilters(pageLoadComplete);
            } else {
                requireLogin();
            }

            const userHasRSICLists = responseParsed.user_details.premiumFeatures.includes("rsics");
            if (!userHasRSICLists) {
                filters.upgradableFilter("RSICs", "rsics_filter");
            }

            setUpgradeSkillsInclusion();
        }

        const checkUserStatusError = function () {
            requireLogin();
        }

        coreFunctions.xhrHelper(method, url, checkUserStatusSuccess, checkUserStatusError, input);
    }

    // Controls whether the navigate to list button is still active
    function updateNavigationButton() {
        // List to navigate back to. Show element
        if (coreFunctions.getQueryVariable("origin_list") == "true") {
            navigateBackButton.classList.remove("hidden");
        }
        // Hide the control
        else {
            navigateBackButton.classList.add("hidden");
        }
    }

    function insightsErrorButtonClick(element) {
        resetInsightPageContent();
        setTimeout(function () {
            coreFunctions.hideOverlay(element);
        }, 500);
    }

    // Reset input page to initial state.
    function resetInsightPageContent() {
        // Reset title and select dropdown
        insightsMainTitle.innerHTML = "Insights";
        listSelectControl.value = "null";

        // Remove summary content
        cutoffSummary.innerHTML = "&nbsp;"

        // No cutoff value currently available, add a placeholder
        listCutoffInput.value = 0;

        // Hide download button until there is content
        downloadAllInsightsButton.classList.add("downloadHidden")

        // Remove any exisiting content,
        while (listSummaryHolder.firstChild.nextSibling) {
            listSummaryHolder.removeChild(listSummaryHolder.nextSibling);
        }
        // No list has been preloaded
        listSummaryHolder.innerHTML = "<p>Pick one of your saved lists above to discover extra insights about the companies it contains.</p>";

        document.getElementById("listInsightsPageLoadingHolder").classList.remove("active");
    }

    function toggleMobileHeaderControls(element) {
        var headerControls = element.closest(".controlsBar");
        if (headerControls) {
            if (headerControls.classList.contains("mobileControlsVisible")) {
                headerControls.classList.remove("mobileControlsVisible");
            } else {
                headerControls.classList.add("mobileControlsVisible");
            }
        }
    }

    function pageLoadComplete() {
        companyLists.getSavedCompanyLists();
    }

    // Close tab to go back to the list
    function navigateBack() {
        history.back();
    }

    function loadingComplete() {
        document.getElementById("main").classList.remove("mainHidden");
        checkUrlQueryFields();
        companyLists.recalculateInsights();
    }

    function  checkUrlQueryFields() {
        let queryListID, queryModelCode, queryCutoff, queryListSize, exploreListID, queryRtic, rticSector, rticVertical, classificationRelease, prefilterCode;
        if (queryListID = coreFunctions.getQueryVariable("list_id")) {
            companyLists.presetList(queryListID);
        }
        if (classificationRelease = coreFunctions.getQueryVariable("classification_release")) {
            companyLists.classificationRelease = classificationRelease;
        }
        if ((queryListID = coreFunctions.getQueryVariable("list_id")) && (queryModelCode = coreFunctions.getQueryVariable("model_code"))) {
            companyLists.validatePresetModelCode(Number(queryListID), queryModelCode);
        }
        if (prefilterCode = coreFunctions.getQueryVariable("prefilter")) {
            let allCompaniesList = companyLists.lists.find(element => element.listID == "All");
            allCompaniesList.prefilterCode = prefilterCode;
            allCompaniesList.prefilterName = decodeURIComponent(coreFunctions.getQueryVariable("prefilter_name") ?? '');
            filters.processStoredGeneralFilters({SelectedISCodes: [prefilterCode] }); // Preset IS Codes filter
        }
        if (queryCutoff = coreFunctions.getQueryVariable("list_cutoff")) {
            document.getElementById("listCutoffInput").value = queryCutoff;
        }
        if ((queryListSize = coreFunctions.getQueryVariable("list_size")) && document.querySelector(`#cutoffByListSizeSelect option[value='${queryListSize}']`)) {
            document.getElementById("cutoffByListSizeSelect").value = queryListSize;
            companyLists.toggleCutoffControl(document.getElementById("cutoffByListSizeControlHolder"));
        }
        if (queryRtic = coreFunctions.getQueryVariable("rtic")) {
            rticSector = decodeURIComponent(queryRtic);
            rticVertical = (coreFunctions.getQueryVariable("vertical") ? decodeURIComponent(coreFunctions.getQueryVariable("vertical")) : null);
            filters.rticFilters.preloadRticSector(rticSector, rticVertical);
        }
    }

    class CompanyLists {
        classificationRelease;

        constructor(activeListID) {
            this.activeListID = activeListID;
            this.lists = [];
        }

        // Get users saved lists to add to select tag
        getSavedCompanyLists() {
            let method, url;
            const listsObject = this;

            method = "GET";
            url = `../api/lists/lists_actions.php?action=getmllistsanalyse`;

            const getSavedCompanyListsSuccess = function (response) {
                const responseParsed = JSON.parse(response);
                listsObject.getSavedCompanyListsLoad(responseParsed);
            }

            const getSavedCompanyListsError = function () {
                const response = {
                    "status": "error"
                }
                listsObject.getSavedCompanyListsLoad(response);
            }

            coreFunctions.xhrHelper(method, url, getSavedCompanyListsSuccess, getSavedCompanyListsError);
        }

        getSavedCompanyListsLoad(response) {
            const listsObject = this;
            // Add list for all companies
            listsObject.newCompanyList("All", "All UK companies", null, null, null);
            // Lists have been loaded
            if (response.status == "success") {
                // Add user lists with details
                response.companies_lists.forEach(list => listsObject.newCompanyList(list.list_id, list.title, list.return_count, list.trainingCompanies.include.map(company => company.companynumber), list.trainingCompanies.exclude.map(company => company.companynumber), list.manualIncludes, list.manualExcludes).addOptionToListSelect());
                exploreList.checkForRequestedExploreList(loadingComplete);
            } else {
                // TODO
                // insightProcessingError("Could not process insights", "An error occured while processing insights for this list. Please try again.", true);
                console.log("Could not retrieve lists");
                exploreList.checkForRequestedExploreList(loadingComplete);
            }
        }

        newCompanyList(listID, title, returnCount, trainingSetInclude, trainingSetExclude, manualIncludes, manualExcludes) {
            let companyList = new CompanyList(listID, title, returnCount, trainingSetInclude, trainingSetExclude, manualIncludes, manualExcludes);
            this.lists.push(companyList);
            return companyList;
        }

        presetList(listID) {
            if (document.querySelector(`#listSelectControl option[value='${listID}']`)) {
                document.getElementById("listSelectControl").value = listID;
                this.listSelectControlChange(listID);
            }
            return this;
        }

        validatePresetModelCode(listID, modelCode) {
            let matchingList;
            if (matchingList = this.lists.find(list => list.listID == listID)) {
                matchingList.presetModelCode(modelCode);
            }
        }

        listSelectControlChange(listID) {
            this.activeListID = listID;
            if (listID == "All") {
                // Deactivate cutoff controls when All insights is selected
                document.getElementById("cutoffByListSizeControlHolder").classList.add("completeListActive");
                document.getElementById("cutoffByScoreControlHolder").classList.add("completeListActive");
            } else {
                // Allows custom cutoffs to be chosen
                document.getElementById("cutoffByListSizeControlHolder").classList.remove("completeListActive");
                document.getElementById("cutoffByScoreControlHolder").classList.remove("completeListActive");

                // No control is currently active, set default to match score
                if (document.querySelector("#cutoffControls .controlHolder.active") == undefined) {
                    document.getElementById("cutoffByScoreControlHolder").classList.add("active");
                    document.getElementById("listCutoffInput").value = 0;
                }
            }
        }

        recalculateInsights(allowLargeAnalysis = false) {
            if(document.querySelectorAll('.listSummaryWrapper .summary-table-wrapper tbody').length > 0) {
                document.getElementById('summaryTableToggle').checked = false;
                document.querySelector('.listSummaryWrapper .summary-table-wrapper tbody').innerHTML = '';
            }
            this.lists.find(list => list.listID == this.activeListID).initiateListInsightsCalculations(this.classificationRelease, allowLargeAnalysis);
        }

        toggleCutoffControl(element) {
            if (element.classList.contains("active") == false) {
                if (document.querySelector("#cutoffControls .controlHolder.active")) {
                    document.querySelector("#cutoffControls .controlHolder.active").classList.remove("active");
                }
                element.classList.add("active");
            }
        }

    }

    class CompanyList {
        prefilterCode;
        prefilterName;
        allowLargeAnalysis = false;
        constructor(listID, title, returnCount, trainingSetInclude, trainingSetExclude, manualIncludes, manualExcludes) {
            this.listID = listID;
            this.title = title;
            this.returnCount = returnCount;
            this.trainingSetInclude = trainingSetInclude;
            this.trainingSetExclude = trainingSetExclude;
            this.manualIncludes = manualIncludes;
            this.manualExcludes = manualExcludes;
            this.modelCode = null;
            this.listValidated = false
        }

        addOptionToListSelect() {
            document.getElementById("listSelectControl").appendChild(coreFunctions.createElementHelper("option", { innerHTML: this.title, value: this.listID }));
        }

        // Begin list insights process
        initiateListInsightsCalculations(classificationRelease, allowLargeAnalysis = false) {
            this.allowLargeAnalysis = allowLargeAnalysis;
            if (this.listID == "All") {
                this.processCompleteListAnalyis();
            } else {
                // Modelcode for list and list has finished processing
                if (this.listValidated) {
                    this.checkListCutoffMethod();
                }
                // Retrieve list model code, and check list has completed processing
                else {
                    this.validateListAndGetModelCode(classificationRelease);
                }
            }
        }

        presetModelCode(modelCode) {
            this.modelCode = modelCode;
        }

        // Check how the list is being cutoff
        checkListCutoffMethod() {
            // Cutoff is by list size, will need to calculate corresponding score
            if (this.cutoffIsByListSize()) {
                this.getListSizeToScore();
            }
            // Cutoff is by score alone
            else {
                this.getListInsights(Number(document.getElementById("listCutoffInput").value), null);
            }
        }

        validateListAndGetModelCode(classificationRelease) {
            const companyListObject = this;
            this.showInsightsLoadingOverlay();

            const method = "POST";
            const url = `../api/ml_list/ml_list_actions.php?action=getmodelcode&listid=${this.listID}&classification_release=${classificationRelease ?? "latest"}`;
            const input = {
                trainingSetInclude: this.trainingSetInclude,
                trainingSetExclude: this.trainingSetExclude
            }

            const validateListAndGetModelCodeSuccess = function (response) {
                const responseParsed = JSON.parse(response);
                if (responseParsed.status == "success") {
                    if (responseParsed.listComplete == true) {
                        companyListObject.listValidated = true;
                        companyListObject.modelCode = responseParsed.modelCode;
                        // Update training set with entries available in the current database. Add current manually included/excluded companies
                        companyListObject.trainingSetInclude = responseParsed.trainingSetInclude;
                        companyListObject.trainingSetExclude = responseParsed.trainingSetExclude;
                        companyListObject.manualExcludes = responseParsed.manualExcludes;
                        companyListObject.manualIncludes = responseParsed.manualIncludes;

                        companyListObject.checkListCutoffMethod();
                    } else {
                        // List has not finished processing
                        companyListObject.insightProcessingError("Could not process insights", `${companyListObject.title} has not finished being classified. Go back to the list page to complete processing.`, true);
                    }
                }
                // Error
                else {
                    companyListObject.insightProcessingError("Could not process insights", "An error occured while processing insights for this list. Please try again.");
                }
            }

            const validateListAndGetModelCodeError = function () { }

            coreFunctions.xhrHelper(method, url, validateListAndGetModelCodeSuccess, validateListAndGetModelCodeError, JSON.stringify(input));
        }

        cutoffIsByListSize() {
            return document.getElementById("cutoffByListSizeControlHolder").classList.contains("active");
        }

        // Calculate corresponding score of a list size
        getListSizeToScore() {
            this.showInsightsLoadingOverlay();
            let method, url, input;
            const companyListObject = this;

            method = "POST";
            url = `../api/ml_list/ml_list_actions.php?action=listsizetoscore&listid=${this.listID}`;

            input = {
                trainingSetInclude: this.trainingSetInclude,
                trainingSetExclude: this.trainingSetExclude,
                returnCount: Number(document.getElementById("cutoffByListSizeSelect").value)
            }

            const getListSizeToScoreSuccess = function (response) {
                const responseParsed = JSON.parse(response);
                if (responseParsed.status == "success") {
                    companyListObject.getListInsights(responseParsed.listEndScore);
                } else {
                    companyListObject.insightProcessingError("Could not process insights", "An error occured while processing insights for this list. Please try again.");
                }
            }

            const getListSizeToScoreError = function () {
                companyListObject.insightProcessingError("Could not process insights", "An error occured while processing insights for this list. Please try again.");
            }

            coreFunctions.xhrHelper(method, url, getListSizeToScoreSuccess, getListSizeToScoreError, JSON.stringify(input));
        }

        formatPrefilterTitle() {
            return this.prefilterName.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase()) + ` (${this.prefilterCode})`;
        }

        showInsightsLoadingOverlay() {
            let insightsTitle = this.title;
            let prefilterCode;
            if (coreFunctions.getQueryVariable("rtic")) {
                insightsTitle = filters.rticFilters.formatPreloadedRticName(decodeURIComponent(coreFunctions.getQueryVariable("rtic")), null);
            } else if (coreFunctions.getQueryVariable("explorelist_id")) {
                insightsTitle = exploreList.name;
            } else if (this.prefilterCode) {
                insightsTitle = this.formatPrefilterTitle();
            }
            document.getElementById("listInsightsPageLoadingHolder").classList.add("active");
            document.getElementById("insightsLoadingListName").innerHTML = insightsTitle;
            document.getElementById("insightsMainTitle").innerHTML = `Analysis: ${insightsTitle}`;
            window.scrollTo({top: 0, behavior: 'smooth'}); // Scroll to top of page
            return this;
        }

        // Controls whether the navigate to list button is still active
        updateNavigationButton() {
            // List to navigate back to. Show element
            if (coreFunctions.getQueryVariable("origin_list") == "true") {
                document.getElementById("navigateBackButton").classList.remove("hidden");
            }
            // Hide the control
            else {
                document.getElementById("navigateBackButton").classList.add("hidden");
            }
            return this;
        }

        hideInsightsLoadingOverlay() {
            document.getElementById("listInsightsPageLoadingHolder").classList.remove("active");
            return this;
        }

        processCompleteListAnalyis() {
            this.modelCode = "All";
            this.title = "All UK companies";
            this.manualIncludes = [];
            this.manualExcludes = [];
            this.getListInsights(0, null);
        }

        // Update company filters with any manual includes/excludes belonging to the company list
        setManualIncludesExcludes() {
            filters.companyFilters.setManuallyIncludedCompanyNumbers(this.manualIncludes);
            filters.companyFilters.setManuallyExcludedCompanyNumbers(this.manualExcludes);
            return this;
        }

        updateExploreLink() {
            let listLink = `${urlPath}${(this.listID == "All") ? `/explore?filters_code=${filters.storedFiltersCode}` : `/ml_list?list_id=${this.listID}`}`;
            if (this.prefilterCode) {
                listLink += `&prefilter=${this.prefilterCode}&prefilter_name=${this.prefilterName}`;
            }
            const viewListControls = document.querySelectorAll(".view-list");
            const resultsAreFiltered = listAnalysis.filtersObject.resultsFilteringActive();
            viewListControls.forEach(element => {
                element.href = listLink;
                if (resultsAreFiltered) {
                    element.classList.add("visible");
                } else {
                    element.classList.remove("visible");
                }
            })
            document.getElementById("analysisToListLink").href = listLink;
            return this;
        }

        getListInsightsOnLoad() {
            listAnalysis.analysisLoaded(filters);
            this.hideInsightsLoadingOverlay().updateExploreLink();
        }

        getListInsights(scoreCutoff, returnCount) {
            this.checkPrefilterStatus();
            this.setManualIncludesExcludes().showInsightsLoadingOverlay().updateNavigationButton();
            listAnalysis.filtersObject = filters;
            const filtersForSearch = filters.hideFilterControls().getFiltersForSearch(returnCount);
            filters.saveFiltersState(filters.getFiltersForSavedList());

            listAnalysis.setAnalysisProperties(this.modelCode, this.title, this.listID, scoreCutoff, this.prefilterCode, this.prefilterName).getAnalysis({filtersForSearch: filtersForSearch, callback: this.getListInsightsOnLoad.bind(this), callbackArguments: null, allowLargeAnalysis: this.allowLargeAnalysis});
        }

        // If using prefilter, check to see if it is still active
        checkPrefilterStatus() {
            if (this.prefilterCode) {
                const flattenedFilters = filters.getFlattenedFilters();
                // Filters no longer include original prefilter code
                if (!flattenedFilters.includes(this.prefilterCode)) {
                    this.resetPrefilter();
                }
            }
            return this;
        }

        resetPrefilter() {
            // Reset fields
            this.prefilterCode = null;
            this.prefilterName = null;

            // Remove prefilter search params from URL
            const urlParamsString = window.location.search;
            const urlSearchParams = new URLSearchParams(urlParamsString);
            urlSearchParams.delete("prefilter_name");
            urlSearchParams.delete("prefilter");
            window.history.replaceState('searchquery', 'searchqueryedit', urlSearchParams.toString());
        }

        analysisFieldAvailable(data, field) {
            if (data.hasOwnProperty(field) && data[field] != undefined) {
                if (Array.isArray(data[field]) && data[field].length == 0) {
                    return true;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        }

        // Issues getting insights for a list
        insightProcessingError(heading, text, backToList) {
            // The list has not finished classification. Give user option to go back to page
            if (backToList && backToList == true) {
                // Add text to message
                document.querySelector("#openListOverlay .overlayText").innerHTML = text;
                // Update link back to list
                backToListLink.href = `${urlPath}/companylist?list_id=${this.listID}`;
                showOverlay("openincompletelist");
            } else {
                // Show general error message
                document.querySelector("#insightsErrorOverlay .overlayTitle").innerHTML = heading;
                document.querySelector("#insightsErrorOverlay .overlayText").innerHTML = text;
                showOverlay("insightserror");
            }
        }

        processListInsightsResponse(listAnalysisResponse) {
            return this;
        }
    }

    class ExploreList {
        constructor(listID, name, filters) {
            this.listID = listID;
            this.name = name;
            this.filters = filters;
        }

        checkForRequestedExploreList(callback) {
            let requestedExploreListID;
            if (requestedExploreListID = coreFunctions.getQueryVariable("explorelist_id")) {
                this.listID = Number(requestedExploreListID);
                this.loadExploreListDetails(callback);
            } else {
                callback();
            }
        }

        loadExploreListDetails(callback) {
            let method, url, input, exploreListDetails;
            const exploreListObject = this;

            method = "POST";
            url = `../api/explore/explore_actions.php?action=loadlist&listid=${this.listID}`;
            input = new FormData();
            input.append('listID', this.listID);

            const loadExploreListDetailsSuccess = function (response) {
                const responseParsed = JSON.parse(response);
                if (responseParsed.status == "success") {
                    exploreListDetails = responseParsed.exploreList;
                    exploreListObject.name = exploreListDetails.listName;
                    exploreListObject.filters = JSON.parse(exploreListDetails.filters);

                    // Clear out the explore manually included and excluded companies as it's not support in ML lists
                    delete exploreListObject.filters.filters.ExploreManuallyExclude;
                    delete exploreListObject.filters.filters.ExploreManuallyInclude;

                    exploreListObject.setExploreListFilters(callback);
                } else {
                    callback();
                }
            }

            const loadExploreListDetailsError = function () {
                callback();
            }

            coreFunctions.xhrHelper(method, url, loadExploreListDetailsSuccess, loadExploreListDetailsError, input);
        }

        setExploreListFilters(callback) {
            let exploreListFilters = this.filters;
            filters.processStoredGeneralFilters(exploreListFilters.filters);
            if (exploreListFilters.keywords) {
                filters.keywordFilters.processStoredKeywords(exploreListFilters.keywords).updateKeywordsTotal();
            }
            if (exploreListFilters.rtics) {
                filters.rticFilters.processStoredRticFiltersLegacy(exploreListFilters.rtics);
            }
            filters.dateFilters.processStoredDateFilters(exploreListFilters.filters);
            callback();
        }
    }

    const companyLists = new CompanyLists("All");
    const listAnalysis = new Analysis();
    const filters = new AllFilters("analyse");
    const exploreList = new ExploreList();

    return {
        pageBodyLoad: pageBodyLoad,
        insightsErrorButtonClick: insightsErrorButtonClick,
        toggleMobileHeaderControls: toggleMobileHeaderControls,
        filters: filters,
        companyLists: companyLists,
        listAnalysis: listAnalysis,
        exploreList: exploreList,
        navigateBack: navigateBack,
        positionSectionNavigation: positionSectionNavigation
    }
}();
